import {FireInTheHole2} from "../FireInTheHole2";

export class FITH2ReelBackground extends PIXI.Container {
    private _reelBg: PIXI.Sprite;
    private _reelFrame: PIXI.Sprite;

    constructor() {
        super();
        this.name = "ReelBackground";
        this.init();
        this.position.set(360, 360);
    }

    private init() {
        this._reelBg = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("reel_bg")[0]);
        this._reelBg.anchor.set(0.5, 0.5);
        this._reelBg.position.set(0, 0);
        this._reelBg.scale.set(2);
        this._reelFrame = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("reel")[0]);
        this._reelFrame.anchor.set(0.5, 0.5);
        this._reelFrame.position.set(0, 0);
        this.addChild(this._reelBg, this._reelFrame);
    }

    public onSpin(): void {

    }

    public setMode(mode: string): void {
        this._reelBg.visible = mode[0] === "N";
        this._reelFrame.visible = mode[0] === "N";
    }

    public onWinToggle(): void {
        return;
    }
}